/**
 * @generated SignedSource<<d97e0898f4f9f99270efdc3e6cfa4a37>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StorecastScreenAdminDismissInfoMutation$variables = {
  screenId: string;
};
export type StorecastScreenAdminDismissInfoMutation$data = {
  readonly storecast: {
    readonly dismissInfo: {
      readonly id: string;
    };
  };
};
export type StorecastScreenAdminDismissInfoMutation = {
  response: StorecastScreenAdminDismissInfoMutation$data;
  variables: StorecastScreenAdminDismissInfoMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "screenId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StorecastMutation",
    "kind": "LinkedField",
    "name": "storecast",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "screenId",
            "variableName": "screenId"
          }
        ],
        "concreteType": "StorecastScreen",
        "kind": "LinkedField",
        "name": "dismissInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StorecastScreenAdminDismissInfoMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StorecastScreenAdminDismissInfoMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f89e7abaad75c4c961ec4fdafef79db3",
    "id": null,
    "metadata": {},
    "name": "StorecastScreenAdminDismissInfoMutation",
    "operationKind": "mutation",
    "text": "mutation StorecastScreenAdminDismissInfoMutation(\n  $screenId: ID!\n) {\n  storecast {\n    dismissInfo(screenId: $screenId) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "07d182ff2ccea0025e7aef23d81d9782";

export default node;
